import axios from 'axios';
import { GetBackendUrlForGlobalFunctions } from '../../App';
export const getElementAlias = (isWorkbench: boolean) => {
  return axios.get(
    GetBackendUrlForGlobalFunctions() +
      `shift/element-alias?where=` +
      isWorkbench
  );
};
export const addElementAlias = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `shift/element-alias/add`,
    obj,
    {
      headers,
    }
  );
};
export const editElementAlias = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `shift/element-alias/update`,
    obj,
    {
      headers,
    }
  );
};
export const deleteElementAlias = (obj: Object) => {
  const headers = {
    'Content-Type': 'application/json',
  };
  return axios.put(
    GetBackendUrlForGlobalFunctions() + `shift/element-alias/delete`,
    obj,
    {
      headers,
    }
  );
};
